<template>
  <div class="company-card--container" :class="{active_card: active == 1}">
    <div class="top">
      <div class="left">
        <div class="img"><img :src="img"></div>
      </div>
      <div class="right">
        <div class="name">{{name}}</div>
        <div class="city">{{city}}</div>
        <div class="address">{{address}}</div>
        <div class="number">{{numberComputed}}</div>
      </div>
    </div>
    <div class="bottom mrg-t-10">
      <div class="left">
        <div v-if="hideButtons == 0" class="active-status">
          <div class="active" v-if="active == 1">Выбрана</div>
          <div @click="emitActive" class="btn btn-sm btn-info" v-if="active == 0">Переключиться</div>
        </div>
      </div>
      <div class="right">
        <div v-if="hideButtons == 0" class="actions">
          <div
              v-if="checkPermission('update_filial')"
              @click="emitEdit"
              class="btn btn-sm btn-outline-info"
          >Изменить</div>
          <div
              v-if="checkPermission('delete_filial') && active == 0"
              @click="emitDelete"
              class="btn btn-sm btn-danger"
          >
            <f-awesome icon="times"></f-awesome>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import permissionMixin from '@/components/mixins/Permissions';

export default {
  name: "CompanyCard",
  components: {},
  data() {
    return {

    };
  },
  mixins: [permissionMixin],
  props: {
    id: Number,
    active: Number,
    img: String,
    name: String,
    city: String,
    address: String,
    number: String,
    hideButtons: Number
  },
  watch: {

  },
  computed: {
    numberComputed(){
      let result = '';
      if(this.number != ''){
        if(this.number.match(/\+/)){
          result = this.number;
        }else{
          result = '+' +this.number;
        }
      }
      return result;
    }
  },
  methods: {
    emitActive(){
      this.$emit('active', this.id);
    },
    emitEdit(){
      this.$emit('edit', this.id);
    },
    emitDelete(){
      this.$emit('delete', this.id);
    }
  }
};
</script>

<style scoped lang="less">
.active_card{
  box-shadow: 0px 5px 9px 0px rgba(0, 0, 0, 0.25);
}
.company-card--container{
  width: 100%;
  border-radius: 8px;
  padding: 10px 6px;
  box-sizing: border-box;

  .top{
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-around;
    flex-direction: row;

    .right{
      padding-top: 5px;
    }
  }
  .bottom{
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-around;
    flex-direction: row;
  }

  .left{
    text-align: center;
    width: 38%;
    .img{
      img{
        width: 80px;
      }
    }
    .active{
      font-size: 12px;
      color: #F97979;
    }
  }
  .right{
    width: 57%;
    .name{
      font-size: 12px;
      font-weight: 500;
      height: 15px;
      text-overflow: ellipsis;
      overflow: hidden;
    }
    .city{
      margin-top: 4px;
      font-size: 12px;
    }
    .address{
      font-size: 12px;
    }
    .number{
      margin-top: 2px;
      font-size: 12px;
    }
  }
}
</style>
